export default __webpack_public_path__ + "27857efee5b2fef2d9eae6b9da28feab.svg";